// removed by extract-text-webpack-plugin
module.exports = {"root":"order-card--root--2qsRDj3-","rollover":"order-card--rollover--1VOkH3Ny","header":"order-card--header--1yBG70qV","body":"order-card--body--N03E2PVP","box-icon":"order-card--box-icon--19k5oOfs","boxIcon":"order-card--box-icon--19k5oOfs","shipment":"order-card--shipment--2MSsyXj-"};


//////////////////
// WEBPACK FOOTER
// ./components/order-grid/order-card/styles.css
// module id = ./components/order-grid/order-card/styles.css
// module chunks = 0